import React from 'react';

interface IDocumentsListInfoText {
  className?: string;
  text?: string | boolean | null;
  ariaLabel?: string;
}

export const DocumentsListInfoText = ({
  className,
  text,
  ariaLabel,
}: IDocumentsListInfoText) => {
  return (
    <span aria-label={ariaLabel} className={className}>
      {text}
    </span>
  );
};
